<template>
  <!--头部开始-->
  <el-header class="header" :style="hotelLogoFixed">
    <!--中部开始-->
    <!-- pc版本 -->
    <el-row class="header-middle header-pc">
      <!--左侧logo 开始-->
        <el-col :span="12" class="grid-content bg-purple left-logo">
          <img class="img" src="https://res.roompai.com/static/img/logo-1.png" style="cursor:pointer;" @click="gotoHome">
        </el-col>
      <!--左侧logo 结束-->
      <!--右侧 开始-->
      <el-col :span="12" class="header-login">
        <div class="grid-content bg-purple right-header">
          <el-menu :default-active="defaultActive" class="el-menu-demo" menu-trigger="click" :unique-opened="true" mode="horizontal" @select="handleSelect" ref="headMenu">
            <el-submenu index="1" popper-class="languageClass" v-show="languageShow">
              <template slot="title">{{webLanguage}}</template>
              <el-menu-item index="1-1" class="langText" @click="languageSwitch('en')" :style="(webLanguage === 'English')?'display:none;':''">English</el-menu-item>
              <el-menu-item index="1-2" class="langText" @click="languageSwitch('zh')" :style="(webLanguage === '简体中文')?'display:none;':''">简体中文</el-menu-item>
            </el-submenu>
            <el-submenu index="2" popper-class="currencyClass" :disabled="currencyDisabled"  v-show="currencyShow">
              <template slot="title">{{webCurrency}}</template>
              <el-menu-item index="2-1" @click="currencySwitch('USD')" v-show="currencyUSDShow" :style="(webCurrency === 'USD')?'display:none;':''">USD<span class="currency">$</span></el-menu-item>
              <el-menu-item index="2-2" @click="currencySwitch('CNY')" v-show="currencyCNYShow" :style="(webCurrency === 'CNY')?'display:none;':''">CNY<span class="currency">￥</span></el-menu-item>
            </el-submenu>
            <el-submenu index="3" v-show="userLogin && this.curPageData !== 'TripDetailTemporary'">
              <template slot="title">
                <el-avatar :src="loginHeadImg"></el-avatar>
                <span class="username font-gray" style="overflow: hidden;width: 40px;display: inline-block;text-overflow: ellipsis;white-space: nowrap;">{{LoginFirstName}}</span>
              </template>
              <div class="userItem">
                <el-menu-item index="" style="font-size: 16px;height:50px; line-height:50px;font-weight: 650;text-align:center;background-color:rgb(79,79,76,1);color:#FFFFFF;margin-bottom: 10px;" onMouseOver="this.style.color='rgb(252,210,5)'" onMouseOut="this.style.color='#FFF'">Hi {{LoginFirstName|capitalize}}!</el-menu-item>
                <el-menu-item @click="accountClick('my_booking')" style="font-size: 16px;height:50px; line-height:50px;">{{$t('myBookings')}}</el-menu-item>
                <el-menu-item @click="accountClick('my_account')" style="font-size: 16px;height:50px; line-height:50px;">{{$t('myAccount')}}</el-menu-item>
                <el-menu-item @click="accountClick('my_collection')" style="font-size: 16px;height:50px; line-height:50px;">{{$t('myFavorite')}}</el-menu-item>
                <el-menu-item @click="accountClick('my_coupon')" style="font-size: 16px;height:50px; line-height:50px;">{{$t('coupon')}}</el-menu-item>
                <el-menu-item index="" style="margin-top: 5px;" onMouseOver="this.style.background='rgba(255, 255, 255, 1)'" onMouseOut="this.style.background='rgba(255, 255, 255, 1)'">
                  <el-button class="out_button" @click="loginOut">{{$t('signOut')}}</el-button>
                </el-menu-item>
              </div>
            </el-submenu>
            <el-menu-item v-show="showLogin" @click="gotoSignIn()" style="color:#4F4C4C;background-color: #FFF;font-size: 15px;">{{$t('signIn')}}</el-menu-item>
          </el-menu>
        </div>
      </el-col>
      <!--右侧 结束-->
    </el-row>

    <!-- 手机版 -->
    <el-row class="header-middle header-mobile">
      <div class=".header-mini-menu inner-left" v-if="$route.path === '/hotelsearch/HotelList' || $route.path === '/hotelsearch/HotelDetail'" >
        <a href="javascript:void(0)" @click="gotoPrevPage($event)">
          <div style="height: 35px;font-size: 25px;width: 35px;line-height: 34px;">
            <img src="/static/img/home/left-rotation.png" style="height: 22px;width: 22px;padding-left: 2px;">
          </div>
        </a>
      </div>
      <!--左侧logo 开始-->
      <el-col :span="12" class="grid-content bg-purple left-logo-mobile" @click="gotoHome">
        <img class="img-mobile" src="https://res.roompai.com/static/img/logo-1.png" @click="gotoHome">
      </el-col>
      <!--左侧logo 结束-->
      <div class="header-mini-menu inner-header" @click="HomeRightMenu= true" style="display: flex;align-items: center;justify-content:center;">
          <!--已登录样式-->
          <img  v-show="userLogin" class="el-avatar el-avatar--circle" :src="loginHeadImg">
          <!--两条横线菜单-->
          <div v-show="userLogin == false" class="inner-header-icon inner-header-icon-out">
              <span></span>
              <span></span>
              <span></span>
          </div>
      </div>
      <!--右侧 结束-->
    </el-row>
    <!--中部结束-->

    <div style="clear:both"></div>
    <!-- menu -->
    <el-row :span="12">
      <el-drawer title="" :visible.sync="HomeRightMenu" :modal-append-to-body="false" size="85%" class="alert-menu" :with-header="false" >

        <el-row class="right-menu-Tips" v-show="showLogin">
          <el-col :span="24" > {{$t('youCanLoginAlterPrice')}} </el-col>
        </el-row>

        <el-row class="right-menu-title" v-show="showLogin">
          <el-col :span="24">
            <router-link :to="{name:'login', params: {'querys': common.linkEncode({'source': source, 'conver': conver}, 'obj')}}">
              <button @click="login">{{$t('signIn')}} / {{$t('createAccount')}}</button>
            </router-link>
          </el-col>
        </el-row>

        <el-row class="right-menu-Tips" style="margin: 10px 25px 25px;font-size:20px" v-show="userLogin">
          <el-col :span="24" > Hi {{LoginFirstName}} </el-col>
        </el-row>

        <div class="menu-height-5 border-bottom-solid"></div>

        <el-row class="right-menu right-menu-group">
          <el-col :span="24" class="right-ment-setup">
            <div class="opclick" @click="vconsoleTool()">{{$t('setUp')}}</div>
          </el-col>
        </el-row>

        <div class="right-menu" @click="languageSetup = true" v-if="languageShow">
          <el-col :span="12" class="alert-left menu-language">
            <span>{{$t('languageAll')}}</span>
          </el-col>
          <el-col :span="12" class="alert-right">
            <img src="https://res.roompai.com/static/img/home/china.png" alt="" v-if="webLanguage === '简体中文'">
            <img src="https://res.roompai.com/static/img/home/english.png" alt="" v-if="webLanguage === 'English'">
          </el-col>
        </div>

        <div class="right-menu" @click="currencySetup = true" v-show="currencyShow">
          <el-col :span="12" class="alert-left menu-currency">
            <span>{{$t('currency')}}</span>
          </el-col>
          <el-col :span="12" class="alert-right"> {{webCurrency}} </el-col>
        </div>

        <div class="right-menu">
          <el-col :span="24" class="alert-left menu-faq" >
            <div class="header-link" @click="gotoOtherPage('frequently')">{{$t('faq')}}</div>
          </el-col>
        </div>

        <div class="right-menu">
          <el-col :span="24" class="alert-left menu-privacyPolicy">
            <div class="header-link" @click="gotoOtherPage('policy')">{{$t('privacyPolicy')}}</div>
          </el-col>
        </div>

        <div class="right-menu">
          <el-col :span="24" class="alert-left menu-termsOfUse">
            <div class="header-link" @click="gotoOtherPage('clause')">{{$t('termsOfUse')}}</div>
          </el-col>
        </div>

        <div class="right-menu">
          <el-col :span="24" class="alert-left menu-aboutUs">
            <div class="header-link" @click="gotoOtherPage('aboutUs')">{{$t('aboutUs')}}</div>
          </el-col>
        </div>

        <div class="right-menu">
          <el-col :span="24" class="alert-left menu-refundPolicy">
            <div class="header-link" @click="gotoOtherPage('refundPolicy')">{{$t('refundPolicy')}}</div>
          </el-col>
        </div>

        <div class="right-menu">
          <el-col :span="24" class="alert-left menu-contactUs">
            <div class="header-link" @click="gotoOtherPage('contactUs')">{{$t('contactUs')}}</div>
          </el-col>
        </div>

        <div class="menu-height-5 border-bottom-solid" v-show="userLogin"></div>
        <div class="menu-height-5"></div>

        <el-row class="right-menu right-menu-group"  v-show="userLogin">
          <el-col :span="24" class="right-ment-setup"> {{$t('myAccount')}} </el-col>
        </el-row>

        <el-row class="right-menu"  v-show="userLogin">
          <el-col :span="24" class="alert-left menu-myBookings" >
            <div @click="accountClick('my_booking')">{{$t('myBookings')}}</div>
          </el-col>
        </el-row>

        <el-row class="right-menu" v-show="userLogin">
          <el-col :span="24" class="alert-left menu-myAccount" >
            <div @click="accountClick('my_account')">{{$t('myAccount')}}</div>
          </el-col>
        </el-row>

        <el-row class="right-menu"   v-show="userLogin">
          <el-col :span="24" class="alert-left menu-myFavorite" >
            <div @click="accountClick('my_collection')">{{$t('myFavorite')}}</div>
          </el-col>
        </el-row>

        <el-row class="right-menu"   v-show="userLogin">
          <el-col :span="24" class="alert-left menu-myCoupon" >
            <div @click="accountClick('my_coupon')">{{$t('coupon')}}</div>
          </el-col>
        </el-row>

        <div class="menu-height-5 border-bottom-solid"  v-show="userLogin"></div>
        <div class="menu-height-5"  v-show="userLogin"></div>

        <el-row class="right-menu" v-show="userLogin">
          <el-col :span="24" class="alert-left menu-signOut">
            <div @click="loginOut">{{$t('signOut')}}</div>
          </el-col>
        </el-row>

      </el-drawer>
    </el-row>

    <publicSetup :languageSetup="languageSetup" :webLanguage="webLanguage" @closepop="closepopSetup"></publicSetup>
    <publicSetup :currencySetup="currencySetup" :webCurrency="webCurrency" @closepop="closepopSetup"></publicSetup>
  </el-header>
  <!--头部结束-->
</template>

<script>
import { getUserInfo } from '@/request/user.js'
import { signIn } from '@/request/login.js'
import { eventBus } from '@/util/languageHeader.js'
import publicSetup from '@/components/public/publicSetup'
export default {
  name: 'publicHeader',
  props: {
    currencyShow: {
      default: true
    },
    hotelLogoFixed: {
      default: false
    },
    curPageData: {
      default: ''
    },
    accountChange: '',
    setCurrency: ''
  },
  components: {
    publicSetup
  },
  data () {
    return {
      defaultActive: '',
      HomeRightMenu: false,
      userLogin: false,
      showLogin: ['WritePay', 'PayCallbackResult', 'TripDetail'].includes(this.curPageData) === false,
      languageSetup: false,
      currencySetup: false,
      webLanguage: this.common.webLanguage,
      webCurrency: this.common.webCurrency,
      LoginFirstName: '',
      currencyDisabled: false,
      currencyCNYShow: true,
      currencyUSDShow: true,
      loginHeadImg: 'https://res.roompai.com/static/img/u527.png', // 默认头像.
      languageShow: true,
      source: 'roompai',
      conver: ''
    }
  },
  watch: {
    HomeRightMenu: function (news, olds) {
      if (news === false) {
        this.languageSetup = false
        this.currencySetup = false
      }
    },
    accountChange: function () {
      // console.log('account info change getHeadUserInfo')
      this.getHeadUserInfo()
    },
    setCurrency: function (s) {
      if (s === 'CNY' || s === 'USD') {
        this.webCurrency = s
      }
    }
  },
  beforeMount () {
    // console.log('head init getHeadUserInfo')
    this.getHeadUserInfo()
  },
  created () {
    // console.log(this.$route.path)
    // 语言language-新：1.query中language设置、2localStorage中的languageSet、3后台设置的语言默认值
    let urlLan = this.common.linkQuerys.language
    let languageSet = localStorage.getItem('languageSet')
    // console.log('localStorage获取到的配置language:' + languageSet)
    if (urlLan === 'en' || urlLan === 'zh') {
      // console.log('url中设置language:' + urlLan)
      this.languageSwitch(urlLan)
    } else if (languageSet === 'en' || languageSet === 'zh') {
      // console.log('localStorage中设置language:' + languageSet)
      this.languageSwitch(languageSet)
    } else {
      // console.log('language not set,waiting admin config')
    }

    // 币种currency-新：1.query中currency设置、2localStorage中的languageSet、3后台设置的语言默认值
    let urlCur = this.common.linkQuerys.currency
    let currencySet = localStorage.getItem('currencySet')
    // console.log('localStorage获取到的配置currency:' + currencySet)
    if (urlCur === 'CNY' || urlCur === 'USD') {
      // console.log('url中设置的currency:' + urlCur)
      this.currencySwitch(urlCur)
    } else if (currencySet === 'CNY' || currencySet === 'USD') {
      // console.log('localStorage中设置的currency:' + currencySet)
      this.currencySwitch(currencySet)
    } else {
      // console.log('currency not set, waiting admin config')
    }

    // 判断 地址中是否包含source 获取source
    // let params = new URL(location.href).searchParams
    // let source = params.get('source')
    let params = this.common.linkQuerys
    let source = params['source']
    if (source === null || source === undefined) {
      source = this.common.webSource
    }

    // 保存当前页面的 regionSel
    var regionSelJson = sessionStorage.getItem('regionSel')
    var regionSelDetail = JSON.parse(regionSelJson)
    if (regionSelDetail !== 'null' && regionSelDetail !== null && regionSelDetail.value_zh != null && regionSelDetail.value_en != null) {
      var regionSel = {'value_zh': regionSelDetail.value_zh, 'value_en': regionSelDetail.value_en, 'type_id': regionSelDetail.type_id, 'type_data_id': regionSelDetail.type_data_id}
      if (this.common.routePath(this.$route.path).indexOf('HotelList') !== -1) {
        sessionStorage.setItem('mobile_hotellist_regionSel', JSON.stringify(regionSel))
      }
      if (this.common.routePath(this.$route.path).indexOf('HotelDetail') !== -1) {
        sessionStorage.setItem('mobile_hoteldetail_regionSel', JSON.stringify(regionSel))
      }
    }
    // 监听点击事件
    let that = this
    document.addEventListener('click', function (e) {
      if (that.$refs.headMenu !== undefined && !that.$refs.headMenu.$el.contains(e.target)) {
        // 在区域外点击时，收起菜单
        that.$refs.headMenu.close('1')
        that.$refs.headMenu.close('2')
        that.$refs.headMenu.close('3')
      }
    })
    if (this.common.linkQuerys.conver === 1 || this.common.linkQuerys.conver === '1') {
      this.conver = this.common.linkQuerys.conver
      console.log('headerConver', this.conver)
    } else {
      var routeParams = this.$route.params
      if (routeParams.conver === 1 || routeParams.conver === '1') {
        this.conver = routeParams.conver
        console.log('headerParamsConver', this.conver)
      }
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  mounted: function () {
    // 存储来源
    var source = this.common.linkQuerys.source
    // 过期时间 5个小时
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
    }
  },
  methods: {
    login: function () {
      let locationHref = window.document.location.href
      sessionStorage.setItem('LoginWebsiteAddress', locationHref)

      // 登录记录埋点
      this.clickPageAction('sign_in', '', {})

      var newQueryStr = this.common.linkEncode({'source': this.source}, 'obj')
      if (this.conver === 1 || this.conver === '1') {
        newQueryStr = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
      }
      this.$router.push({name: 'login', params: {'querys': newQueryStr}})
    },
    gotoHome: function () {
      // 点击埋点
      this.clickPageAction('logo')

      var newQueryStr = this.common.linkEncode({'source': this.source}, 'obj')
      if (this.conver === 1 || this.conver === '1') {
        newQueryStr = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
      }
      this.$router.push({name: 'Home', params: {'querys': newQueryStr}})
    },
    gotoSignIn: function () {
      let locationHref = window.document.location.href
      sessionStorage.setItem('LoginWebsiteAddress', locationHref)

      // 点击埋点
      this.clickPageAction('login')

      var newQueryStr = this.common.linkEncode({'source': this.source}, 'obj')
      if (this.conver === 1 || this.conver === '1') {
        newQueryStr = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
      }
      this.$router.push({name: 'login', params: {'querys': newQueryStr}})
    },
    JumpLogOut: function () {
      var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
      if (this.conver === 1 || this.conver === '1') {
        newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
      }
      this.$router.push({name: 'Home', params: {'querys': newQuerys}})
    },
    handleSelect: function (key, keyPath) {
      this.defaultActive = keyPath.toString()
      if (key !== null && key.indexOf('/') !== -1) {
        this.$router.push(key)
      } else {
        if (key === 1) {
          document.getElementsByClassName('languageClass')[0].css('display', 'none')
        } else if (key === 2) {
          document.getElementsByClassName('currencyClass')[0].css('display', 'none')
        }
      }
    },
    languageSwitch: function (type) {
      // 切换语言
      this.$i18n.locale = type
      if (type === 'zh') {
        this.webLanguage = this.$t('language.zh')
      } else if (type === 'en') {
        this.webLanguage = this.$t('language.en')
      }
      // var urlpath = this.$route.path
      // if (urlpath.indexOf('HotelList') !== -1 || urlpath.indexOf('HotelDetail') !== -1) {
      //   var query = JSON.parse(JSON.stringify(this.common.linkQuerys))
      //   query.language = this.$i18n.locale
      //   this.$router.push({path: this.$route.path, query: query})
      // }
      localStorage.setItem('languageSet', this.$i18n.locale)
      this.$emit('hotelLanguage', this.$i18n.locale)
      eventBus.$emit('language', this.$i18n.locale)
    },
    currencySwitch: function (type) {
      // 切换币种
      this.webCurrency = type
      localStorage.setItem('currencySet', type)
      // var urlpath = this.$route.path
      // if (urlpath.indexOf('HotelList') !== -1 || urlpath.indexOf('HotelDetail') !== -1) {
      //   var query = JSON.parse(JSON.stringify(this.common.linkQuerys))
      //   query.currency = type
      //   this.$router.push({path: this.$route.path, query: query})
      // }
      this.$emit('hotelDetailCurrency', type)
    },
    closepopSetup: function (data) {
      this.HomeRightMenu = false
      if (data.type === 'languageSetup') {
        this.languageSetup = false
        this.languageSwitch(data.languageSetData)
      } else if (data.type === 'currencySetup') {
        this.currencySetup = false
        this.webCurrency = data.currencySetData
        this.$emit('hotelDetailCurrency', data.currencySetData)
      }
    },
    loginOut: function () {
      // 点击埋点
      this.clickPageAction('exit')

      this.userLogin = false
      this.showLogin = true

      // 判断用户是否登录 获取用户信息
      var token = localStorage.getItem('token')
      if (token !== undefined && token !== '' && token !== null) {
        localStorage.removeItem('token')
        localStorage.removeItem('LoginWebsiteAddress')
        var time = parseInt(new Date().getTime() / 1000)
        var dataJson = {'token': token, 'operation': 'loginOut', 'time': time}
        var data = this.common.encryptionData(dataJson, this)
        signIn(data).then(res => {
          this.$nextTick(() => {
            // 埋点日志记录
            let logData = {
              'name': this.$route.name,
              'path': this.$route.path
            }
            this.clickPageAction('loginOut', '', logData, data, res)
          })
          if (this.common.routePath(this.$route.path).includes('/account/')) {
            // this.$router.push({name: 'Home', query: {'source': this.source}})
            var newQueryStr = this.common.linkEncode({'source': this.source}, 'obj')
            if (this.conver === 1 || this.conver === '1') {
              newQueryStr = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
            }
            this.$router.push({name: 'Home', params: {'querys': newQueryStr}})
          }
        })
      }
    },
    gotoPrevPage: function (e) {
      // e.srcElement.style.background = '#5F5D5D'
      if (this.common.routePath(this.$route.path).indexOf('HotelDetail') !== -1) {
        var regionSelJson = sessionStorage.getItem('mobile_hotellist_regionSel')
        var regionSelDetail = JSON.parse(regionSelJson)
        var regionSel = {'value_zh': regionSelDetail.value_zh, 'value_en': regionSelDetail.value_en, 'type_id': regionSelDetail.type_id, 'type_data_id': regionSelDetail.type_data_id}
        sessionStorage.setItem('regionSel', JSON.stringify(regionSel))
      }
      this.$router.go(-1)
    },
    getHeadUserInfo: function () {
      // 判断用户是否登录 获取用户信息
      var token = localStorage.getItem('token')
      if (token !== undefined && token !== '') {
        var time = parseInt(new Date().getTime() / 1000)
        var dataJson = {'token': token, 'isMobile': this.common.isMobile() ? 1 : 0, 'time': time}
        var data = this.common.encryptionData(dataJson, this)
        getUserInfo(data).then(res => {
          // console.log(res)
          if (res.flag === '200') {
            this.userLogin = true
            this.showLogin = false
            this.LoginFirstName = res.data.showNickname
            this.loginHeadImg = res.data.headImgUrl.length > 0 ? res.data.headImgUrl : 'https://res.roompai.com/static/img/u527.png'
            this.$emit('getfirstName', this.LoginFirstName)
          }

          // 语言language-新：1.query中language设置、2localStorage中的languageSet、3后台设置的语言默认值
          let languageSet = localStorage.getItem('languageSet')
          if (languageSet === null || languageSet === '') {
            if (res.data.languageSet) {
              // console.log('admin config set language:' + res.data.languageSet.language)
              this.languageSwitch(res.data.languageSet.language)
            } else {
              this.languageSwitch('en')
            }
          }
          // 语言-如果只有一个语言可选，则隐藏掉语言切换选择器.
          if (res.data.languageSet.hide === '1') {
            // console.log('admin config language only hide switch')
            this.languageShow = false
          }
          // 币种currency-新：1.query中currency设置、2localStorage中的languageSet、3后台设置的语言默认值
          let currencySet = localStorage.getItem('currencySet')
          if (currencySet === null || currencySet === '') {
            if (res.data.currencySet) {
              // console.log('admin config set currency:' + res.data.currencySet.currency)
              this.currencySwitch(res.data.currencySet.currency)
            } else {
              this.currencySwitch('USD')
            }
          }
          // 币种-如果只有一个币种可选，则隐藏掉币种切换选择器.
          if (res.data.currencySet.hide === '1') {
            // console.log('admin config currency only hide switch')
            this.currencyShow = false
          }
        })
      }
    },
    accountClick: function (type) {
      // 点击埋点 埋点记录
      this.clickPageAction(type, '', {'type': type})
      let locationHref = window.document.location.href
      sessionStorage.setItem('LoginWebsiteAddress', locationHref)
      var newQueryStr = this.common.linkEncode({'source': this.source}, 'obj')
      if (this.conver === 1 || this.conver === '1') {
        newQueryStr = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
      }
      if (type === 'my_booking') {
        this.$router.push({name: 'MyTrip', params: {'querys': newQueryStr}})
      } else if (type === 'my_account') {
        this.$router.push({name: 'myAccount', params: {'querys': newQueryStr}})
      } else if (type === 'my_collection') {
        this.$router.push({name: 'myCollection', params: {'querys': newQueryStr}})
      } else if (type === 'my_coupon') {
        this.$router.push({name: 'myCoupon', params: {'querys': newQueryStr}})
      }
    },
    vconsoleTool: function () {
      var vconsole = document.getElementById('__vconsole')
      if (vconsole.style.display === '' || vconsole.style.display === 'none') {
        vconsole.style.display = 'block'
        // 点击埋点 埋点记录
        this.clickPageAction('vconsole', '', {'type': 'vconsole', 'value': 'show'})
      } else {
        vconsole.style.display = 'none'
        // 点击埋点 埋点记录
        this.clickPageAction('vconsole', '', {'type': 'vconsole', 'value': 'hide'})
      }
    },
    gotoOtherPage: function (pagename) {
      let locationHref = window.document.location.href
      sessionStorage.setItem('LoginWebsiteAddress', locationHref)
      var newQueryStr = this.common.linkEncode({'source': this.source}, 'obj')
      if (this.conver === 1 || this.conver === '1') {
        newQueryStr = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
      }
      this.$router.push({name: pagename, params: {'querys': newQueryStr}})
    }
  }
}
</script>

<style scoped>
  .header{padding:0px;}
  .menu-height-5{height:5px;}
  .menu-height-15{height:15px;}
  .border-bottom-solid{border-bottom:solid 1px #ccc;}
  .alert-menu{font-family: PingFangSCRegular, 'PingFang SC', sans-serif;}
  .right-menu-Tips{height:45px;line-height:45px;font-size: 13px;margin: 0px 25px;overflow:hidden;}
  .right-menu-title{height:55px;line-height:55px;font-size: 15px;margin: 0px 25px;}
  .right-menu-title button{width: 100%;height: 45px;border-radius: 3px;border: solid 1px rgba(79, 76, 76, 1);background:rgba(79, 76, 76, 1);color:white;box-shadow: 0 4px 5px 1px #ccc;font-size: 15px;overflow:hidden;}
  .right-menu{margin: 0px 25px;margin-bottom: 10px;height:35px;line-height:35px;font-size: 16px;}
  .right-menu .menu-language{background:url(/static/img/menu/language.png) no-repeat;background-size: 19px;background-repeat: no-repeat;background-position: left;padding-left:35px;}
  .right-menu .menu-currency{background:url(/static/img/menu/currency.png) no-repeat;background-size: 19px;background-repeat: no-repeat;background-position: left;padding-left:35px;}
  .right-menu .menu-faq{background:url(/static/img/menu/FAQ.png) no-repeat;background-size: 19px;background-repeat: no-repeat;background-position: left;padding-left:35px;}
  .right-menu .menu-privacyPolicy{background:url(/static/img/menu/privacyPolicy.png) no-repeat;background-size: 19px;background-repeat: no-repeat;background-position: left;padding-left:35px;}
  .right-menu .menu-termsOfUse{background:url(/static/img/menu/termsOfService.png) no-repeat;background-size: 19px;background-repeat: no-repeat;background-position: left;padding-left:35px;}
  .right-menu .menu-aboutUs{background:url(/static/img/menu/aboutUs.png) no-repeat;background-size: 19px;background-repeat: no-repeat;background-position: left;padding-left:35px;}
  .right-menu .menu-refundPolicy{background:url(/static/img/menu/refundPolicy.png) no-repeat;background-size: 19px;background-repeat: no-repeat;background-position: left;padding-left:35px;}
  .right-menu .menu-contactUs{background:url(/static/img/menu/contactUs.png) no-repeat;background-size: 19px;background-repeat: no-repeat;background-position: left;padding-left:35px;}
  .right-menu .menu-myBookings{background:url(/static/img/menu/myItinerary.png) no-repeat;background-size: 19px;background-repeat: no-repeat;background-position: left;padding-left:35px;}
  .right-menu .menu-myAccount{background:url(/static/img/menu/myAccount.png) no-repeat;background-size: 19px;background-repeat: no-repeat;background-position: left;padding-left:35px;}
  .right-menu .menu-myFavorite{background:url(/static/img/menu/myCollection.png) no-repeat;background-size: 19px;background-repeat: no-repeat;background-position: left;padding-left:35px;}
  .right-menu .menu-myCoupon{background: url(/static/img/account/myCoupon.png) no-repeat;background-size: 15px;background-repeat: no-repeat;background-position: left;padding-left:35px;}
  .right-menu .menu-signOut{background:url(/static/img/menu/signOut.png) no-repeat;background-size: 19px;background-repeat: no-repeat;background-position: left;padding-left:35px;}
  .right-menu .left-ment-setup{text-align:right;font-size:13px;}
  .right-menu .right-ment-setup{font-size:13px;}
  .right-menu .alert-left{overflow: hidden;white-space: nowrap;font-size: 15px;}
  .right-menu .alert-right{text-align:right; color:#4F4C4C;font-size: 15px;}
  .right-menu .alert-right img{width: 32px;height: 20px;margin: -3px 0px;}
  .right-menu-hr{border-bottom:dashed 1px rgba(79, 76, 76, 1);height: 20px;}
  /* .el-menu-item span{color:rgba(0, 0, 0, 0.24705882352941178);} */
  .el-menu--horizontal .el-menu-item:not(.is-disable):hover{color:rgb(252,210,5);background-color:rgb(79,79,76,1);}
  .userItem{padding-bottom:5px;}
  .out_button{width: 100%;background-color: rgba(79, 76, 76, 0.047058823529411764);box-sizing: border-box;border: 1px solid rgba(79, 76, 76, 1);border-radius: 6px;}
  .out_button:hover{background-color:rgb(252,210,5,1);border-color:rgb(252,210,5,1);color:#4F4C4C;}
  .currencyActive{}
  .right-header /deep/ .el-submenu__title{width:100px; padding: 0 !important;font-size: 14px !important;}

  .alert-menu .header-link{color: black;text-decoration: none;}
  .alert-menu .right-menu-group{margin:0px 25px;}
  /deep/ .el-menu .is-disabled .el-submenu__title{color: black !important; opacity:1;}

  .username {
    font-size: 14px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    max-width: 75%;
  }
</style>



// WEBPACK FOOTER //
// src/components/public/publicHeader.vue